import { createSlice } from "@reduxjs/toolkit";
import {
  defaultMenuType,
  subHiddenBreakpoint,
  menuHiddenBreakpoint,
} from "constants/defaultValues";

const initialState = {
  containerClassnames: defaultMenuType,
  subHiddenBreakpoint,
  menuHiddenBreakpoint,
  menuClickCount: 0,
  selectedMenuHasSubItems: false,
  menuPosition: 0
};

const menuSlice = createSlice({
  name: "menu",
  initialState,
  reducers: {
    setContainerClassnames: (state, action) => {
      const { clickIndex, strCurrentClasses, selectedMenuHasSubItems } = action.payload;
      const currentClasses = strCurrentClasses
        ? strCurrentClasses.split(" ").filter((x) => x !== "")
        : [];
      let nextClasses = "";
      let newClickIndex = clickIndex;

      if (!selectedMenuHasSubItems) {
        if (currentClasses.includes("menu-default") && (clickIndex % 4 === 0 || clickIndex % 4 === 3)) {
          newClickIndex = 1;
        }
        if (currentClasses.includes("menu-sub-hidden") && clickIndex % 4 === 2) {
          newClickIndex = 0;
        }
        if (currentClasses.includes("menu-hidden") && (clickIndex % 4 === 2 || clickIndex % 4 === 3)) {
          newClickIndex = 0;
        }
      }

      if (newClickIndex % 4 === 0) {
        nextClasses = currentClasses.includes("menu-default") ? "menu-default" :
                      currentClasses.includes("menu-sub-hidden") ? "menu-sub-hidden" :
                      currentClasses.includes("menu-hidden") ? "menu-hidden" : "";
        newClickIndex = 0;
      } else if (newClickIndex % 4 === 1) {
        nextClasses = currentClasses.includes("menu-default") ? "menu-default sub-hidden" :
                      currentClasses.includes("menu-sub-hidden") ? "menu-sub-hidden main-hidden sub-hidden" :
                      currentClasses.includes("menu-hidden") ? "menu-hidden main-show-temporary" : "";
      } else if (newClickIndex % 4 === 2) {
        nextClasses = currentClasses.includes("menu-default") ? "menu-default main-hidden sub-hidden" :
                      currentClasses.includes("menu-sub-hidden") ? "menu-sub-hidden sub-hidden" :
                      currentClasses.includes("menu-hidden") ? "menu-hidden main-show-temporary sub-show-temporary" : "";
      } else if (newClickIndex % 4 === 3) {
        nextClasses = currentClasses.includes("menu-default") ? "menu-default sub-hidden" :
                      currentClasses.includes("menu-sub-hidden") ? "menu-sub-hidden sub-show-temporary" :
                      currentClasses.includes("menu-hidden") ? "menu-hidden main-show-temporary" : "";
      }
      if (currentClasses.includes("menu-mobile")) {
        nextClasses += " menu-mobile";
      }
      state.containerClassnames = nextClasses;
      state.menuClickCount = newClickIndex;
    },

    clickOnMobileMenu: (state) => {
      const currentClasses = state.containerClassnames.split(" ").filter((x) => x !== "" && x !== "sub-show-temporary");
      let nextClasses = "";
      if (currentClasses.includes("main-show-temporary")) {
        nextClasses = currentClasses.filter((x) => x !== "main-show-temporary").join(" ");
      } else {
        nextClasses = `${currentClasses.join(" ")} main-show-temporary`;
      }
      state.containerClassnames = nextClasses;
      state.menuClickCount = 0;
    },

    changeSelectedMenuHasSubItems: (state, action) => {
      state.selectedMenuHasSubItems = action.payload;
    },

    addContainerClassname: (state, action) => {
      const { classname, strCurrentClasses } = action.payload;
      if (!strCurrentClasses.includes(classname)) {
        state.containerClassnames = `${strCurrentClasses} ${classname}`.trim();
      }
    },

    changeDefaultClassnames: (state, action) => {
      state.containerClassnames = action.payload;
    },

    changeMenuPosition: (state, action) => {
      state.menuPosition = action.payload
    }
  },
});

export const {
  setContainerClassnames,
  clickOnMobileMenu,
  changeSelectedMenuHasSubItems,
  addContainerClassname,
  changeDefaultClassnames,
  changeMenuPosition
} = menuSlice.actions;

export default menuSlice.reducer;